export const getAllUsers = state => state.Users.users;
export const getAllContacts = state => state.Users.contacts;
export const getAllOnlineContacts = state => state.Users.online_contacts;
export const getUser = userId => state =>
  userId ? state.Users.users[userId] : null;
